/* =========================================================
   TIGER 21 GIFT PAGE — behaviour (no dependencies)

   CONFIG: sections/t21-hero.liquid prints <script type="application/json" id="T21Config"> with
     listId        Klaviyo list the guest joins (blank = Shopify customer form only, tagged tiger21-gift;
                   the Shopify Flow "TIGER 21 guest gift card" issues the $300 gift card from that tag)
     companyId     Klaviyo public key
     metric        Klaviyo metric fired on a claim — the gift email flow triggers on it
     source        custom source stored on the subscription + event
     giftCode      optional: a code revealed on the page right after the email is entered
     giftValue     e.g. "$300"
     discountPath  optional: /discount/CODE?redirect= prefix for product links once the code is shown

   FORMS   [data-t21-form]: real Shopify customer forms (tags tiger21-gift,newsletter), so a claim works
           with no JavaScript. With a Klaviyo list set, the email is subscribed through Klaviyo's client
           API, the claim metric is fired (same pattern as assets/klaviyo-subscribe.js) and the page
           shows the claimed state in place.
           Either way the guest stays on this page.
   CLAIMED [data-t21-claimed] blocks show, [data-t21-unclaimed] blocks hide, the 3D card flips to
           its back, and (if a code is set) [data-t21-code] shows it with a copy button.
           Remembered for this browser so a guest who comes back sees their gift, not the form.
   CARD    [data-t21-card]: pointer tilt + moving light on desktop, a gentle scroll sway on phones.
   TRACKING dataLayer + Shopify custom pixel events: t21_gift_claim (map to Meta "Lead"),
           t21_product_click, t21_code_copy.
   ========================================================= */
(function () {
  if (window.__t21Gift) return;
  window.__t21Gift = true;

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('T21Config') || {}).textContent || '{}'); } catch (e) {}
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 't21_gift_claimed';
  var PENDING = 't21_gift_pending';

  function track(name, data) {
    data = data || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- claimed state ---------- */
  /* opts.pending: the claim reached Shopify (fallback form) but not Klaviyo, so the code is not
     "sent" yet: [data-t21-sent] copy hides and [data-t21-pending] copy shows instead. */
  function showClaimed(email, opts) {
    opts = opts || {};
    document.documentElement.classList.add('t21-is-claimed');
    document.documentElement.classList.toggle('t21-is-pending', !!opts.pending);
    document.querySelectorAll('[data-t21-unclaimed]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-t21-claimed]').forEach(function (el) { el.hidden = false; });
    updateDock();
    document.querySelectorAll('[data-t21-sent]').forEach(function (el) { el.hidden = !!opts.pending; });
    document.querySelectorAll('[data-t21-pending]').forEach(function (el) { el.hidden = !opts.pending; });
    /* the full address, not masked: it is the guest's own phone, and it lets her spot a typo */
    document.querySelectorAll('[data-t21-email]').forEach(function (el) { el.textContent = email || el.getAttribute('data-fallback') || ''; });
    document.querySelectorAll('[data-t21-card]').forEach(function (card, i) {
      card.removeAttribute('data-t21-intro');
      setTimeout(function () { card.classList.add('is-flipped'); }, opts.instant ? 0 : 250 + i * 120);
    });
    if (cfg.giftCode) {
      document.querySelectorAll('[data-t21-code]').forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-t21-code-text]').forEach(function (el) { el.textContent = cfg.giftCode; });
      if (cfg.discountPath) {
        document.querySelectorAll('a[data-t21-product]').forEach(function (a) {
          var href = a.getAttribute('href') || '';
          if (href.indexOf('/discount/') === 0) return;
          a.setAttribute('href', cfg.discountPath + encodeURIComponent(href));
        });
      }
    }
    if (opts.focus) {
      var target = document.querySelector('[data-t21-claimed-focus]:not([hidden])') || document.querySelector('[data-t21-claimed]:not([hidden])');
      if (target) {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        /* phones: bring the card to the top so the flip is seen, with the message right under it */
        var narrow = window.matchMedia('(max-width: 749px)').matches;
        var card = document.querySelector('.t21-hero__visual');
        var scrollTo = narrow && card ? card : target;
        scrollTo.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: narrow && card ? 'start' : 'center' });
        setTimeout(function () { target.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      }
    }
  }
  function resetClaim() {
    try { localStorage.removeItem(KEY); localStorage.removeItem(PENDING); } catch (e) {}
    document.documentElement.classList.remove('t21-is-claimed', 't21-is-pending');
    document.querySelectorAll('[data-t21-claimed]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-t21-unclaimed]').forEach(function (el) { el.hidden = false; });
    /* the hero gift set keeps showing the value; only plain cards turn back */
    document.querySelectorAll('[data-t21-card]').forEach(function (card) { if (!card.closest('[data-t21-pack]')) card.classList.remove('is-flipped'); });
    var input = document.querySelector('[data-t21-primary-input]');
    if (input) {
      input.value = '';
      input.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    }
  }
  function bindReset() {
    document.querySelectorAll('[data-t21-reset]').forEach(function (b) {
      if (b.hasAttribute('data-t21-bound')) return;
      b.setAttribute('data-t21-bound', '');
      b.addEventListener('click', resetClaim);
    });
  }

  /* fetch with a timeout, so a stalled request at the venue never leaves the button stuck */
  function post(url, body, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms || 8000) : 0;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(body),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      clearTimeout(timer);
      if (!(r.ok || r.status === 202)) throw new Error('klaviyo ' + r.status);
      return r;
    }, function (e) { clearTimeout(timer); throw e; });
  }

  /* ---------- forms ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function bindForms() {
    document.querySelectorAll('form[data-t21-form]').forEach(function (form) {
      if (form.hasAttribute('data-t21-bound')) return;
      form.setAttribute('data-t21-bound', '');
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      var err = form.querySelector('[data-t21-error]');
      var msgInvalid = form.getAttribute('data-msg-invalid') || 'Please enter a valid email address.';
      var msgFail = form.getAttribute('data-msg-fail') || 'Something went wrong. Please try again.';

      function setError(text) {
        if (err) err.textContent = text || '';
        if (input) input.setAttribute('aria-invalid', text ? 'true' : 'false');
      }
      function busy(on) {
        if (!btn) return;
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
        btn.disabled = !!on;
      }
      /* Klaviyo unreachable (blocked, offline, slow): post the Shopify customer form instead. The guest
         is saved as a customer tagged tiger21-gift and comes back with ?customer_posted=true, where the
         page says the code will follow (it is NOT sent automatically: see the hero section notes). */
      function fallback() {
        busy(false);
        store(PENDING, (input && input.value || '').trim());
        try { form.submit(); } catch (x) { setError(msgFail); }
      }
      input && input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') setError(''); });

      form.addEventListener('submit', function (e) {
        var email = (input && input.value || '').trim();
        if (!EMAIL.test(email)) {
          e.preventDefault();
          setError(msgInvalid);
          input && input.focus();
          return;
        }
        setError('');
        var placement = form.getAttribute('data-t21-form') || 'page';
        track('t21_gift_claim', { placement: placement, value: 300, currency: 'USD' });

        if (!window.fetch) { store(PENDING, email); return; } /* Shopify customer form posts as normal */
        if (!cfg.listId || !cfg.companyId) {
          /* No Klaviyo: the claim IS the Shopify customer (tagged tiger21-gift), and a Shopify Flow
             issues the gift card from that tag. Post the form in the background so the guest stays
             here; Shopify answers with a redirect to return_to?customer_posted=true. Anything else
             (a captcha challenge, a form error) gets the normal page post instead. */
          e.preventDefault();
          busy(true);
          var ctl = window.AbortController ? new AbortController() : null;
          var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
          fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
            .then(function (r) {
              clearTimeout(timer);
              if (!r.ok || !/[?&]customer_posted=true/.test(r.url || '')) throw new Error('shopify form');
              busy(false);
              store(KEY, email);
              showClaimed(email, { focus: true });
            })
            .catch(function () { clearTimeout(timer); fallback(); });
          return;
        }

        e.preventDefault();
        busy(true);
        var q = '?company_id=' + encodeURIComponent(cfg.companyId);
        post('https://a.klaviyo.com/client/subscriptions' + q, {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: cfg.source || 'Guest gift page',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.listId } } }
          }
        }).then(function () {
          /* The gift email flow triggers on this METRIC (the list is the shared Skincare list), so the
             claim only counts as sent once the event is accepted too. */
          return post('https://a.klaviyo.com/client/events' + q, {
            data: {
              type: 'event',
              attributes: {
                properties: { source: cfg.source || '', placement: placement, page: location.pathname, gift_value: cfg.giftValue || '' },
                metric: { data: { type: 'metric', attributes: { name: cfg.metric || 'Claimed Guest Gift' } } },
                profile: { data: { type: 'profile', attributes: { email: email, properties: { gift_event: cfg.source || '' } } } }
              }
            }
          });
        }).then(function () {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') { try { window.klaviyo.identify({ email: email }); } catch (x) {} }
          busy(false);
          store(KEY, email);
          showClaimed(email, { focus: true });
        }).catch(fallback);
      });
    });
  }

  /* ---------- copy code ---------- */
  function bindCopy() {
    document.querySelectorAll('[data-t21-copy]').forEach(function (b) {
      if (b.hasAttribute('data-t21-bound')) return;
      b.setAttribute('data-t21-bound', '');
      b.addEventListener('click', function () {
        var code = cfg.giftCode || '';
        var done = function () {
          var label = b.querySelector('[data-t21-copy-label]') || b;
          var old = label.textContent;
          label.textContent = b.getAttribute('data-copied') || 'Copied';
          setTimeout(function () { label.textContent = old; }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else done();
        track('t21_code_copy', {});
      });
    });
  }

  /* ---------- product + scroll links ---------- */
  function bindLinks() {
    document.querySelectorAll('a[data-t21-product]').forEach(function (a) {
      if (a.hasAttribute('data-t21-bound')) return;
      a.setAttribute('data-t21-bound', '');
      a.addEventListener('click', function () { track('t21_product_click', { product: a.getAttribute('data-t21-product') }); });
    });
    document.querySelectorAll('[data-t21-jump]').forEach(function (a) {
      if (a.hasAttribute('data-t21-bound')) return;
      a.setAttribute('data-t21-bound', '');
      a.addEventListener('click', function (e) {
        var claimed = document.documentElement.classList.contains('t21-is-claimed');
        var target = claimed ? document.querySelector('[data-t21-claimed-focus]') : document.querySelector('[data-t21-primary-input]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        if (!claimed) setTimeout(function () { target.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      });
    });
  }

  /* ---------- 3D card ---------- */
  function bindCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-t21-card]'));
    cards.forEach(function (card) {
      if (card.hasAttribute('data-t21-bound')) return;
      card.setAttribute('data-t21-bound', '');
      var flip = card.querySelector('.t21-card__flip');
      if (flip) flip.addEventListener('animationend', function () { card.removeAttribute('data-t21-intro'); });
      if (reduce) { card.removeAttribute('data-t21-intro'); return; }
      if (card.closest('[data-t21-pack]')) return; /* the gift set tilts as a whole, see bindPack */
      var zone = card.closest('[data-t21-tilt-zone]') || card;
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!fine) return;
      var raf = 0;
      zone.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / (zone === card ? r.width / 2 : window.innerWidth / 2);
        var y = (e.clientY - (r.top + r.height / 2)) / (zone === card ? r.height / 2 : window.innerHeight / 2);
        x = Math.max(-1, Math.min(1, x)); y = Math.max(-1, Math.min(1, y));
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.classList.add('is-tracking');
          card.style.setProperty('--ry', (x * 16).toFixed(2) + 'deg');
          card.style.setProperty('--rx', (-y * 12).toFixed(2) + 'deg');
          card.style.setProperty('--gx', (50 + x * 40).toFixed(1) + '%');
          card.style.setProperty('--gy', (30 + y * 40).toFixed(1) + '%');
        });
      });
      zone.addEventListener('pointerleave', function () {
        cancelAnimationFrame(raf);
        card.classList.remove('is-tracking');
        ['--rx', '--ry', '--gx', '--gy'].forEach(function (p) { card.style.removeProperty(p); });
      });
    });

    /* phones: sway with scroll so the card still feels alive */
    cards = cards.filter(function (c) { return !c.closest('[data-t21-pack]'); }); /* the gift set card sits in its slot */
    if (reduce || window.matchMedia('(hover: hover) and (pointer: fine)').matches || !cards.length) return;
    var ticking = false;
    function sway() {
      ticking = false;
      var vh = window.innerHeight;
      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = ((r.top + r.height / 2) - vh / 2) / vh; /* -0.5 .. 0.5 */
        card.style.setProperty('--ry', (p * -26).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (p * 10).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (50 + p * 70).toFixed(1) + '%');
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sway); } }, { passive: true });
    sway();
  }

  /* ---------- hero gift set: lift, turn over, tilt ---------- */
  function bindPack() {
    var pack = document.querySelector('[data-t21-pack]:not([data-t21-bound])');
    if (!pack) return;
    pack.setAttribute('data-t21-bound', '');
    var card = pack.querySelector('[data-t21-card]');
    var lift = pack.querySelector('[data-t21-pack-lift]');
    var done = false;
    function finish(now) {
      if (done) return;
      done = true;
      pack.classList.add('is-lifted');
      setTimeout(function () { if (card) card.classList.add('is-flipped'); }, now ? 0 : 120);
    }
    if (reduce || !lift) { pack.removeAttribute('data-t21-intro'); finish(true); }
    else {
      lift.addEventListener('animationend', function (e) { if (e.target === lift) finish(); });
      setTimeout(finish, 4200); /* backgrounded tabs can skip animationend */
    }
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var zone = pack.closest('[data-t21-tilt-zone]') || pack;
    var raf = 0;
    zone.addEventListener('pointermove', function (e) {
      var r = zone.getBoundingClientRect();
      var x = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
      var y = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        pack.classList.add('is-tracking');
        pack.style.setProperty('--pry', (-16 + x * 14).toFixed(2) + 'deg');
        pack.style.setProperty('--prx', (5 - y * 7).toFixed(2) + 'deg');
      });
    });
    zone.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      pack.classList.remove('is-tracking');
      pack.style.removeProperty('--pry'); pack.style.removeProperty('--prx');
    });
  }

  /* ---------- product photo galleries ---------- */
  function bindGalleries() {
    document.querySelectorAll('[data-t21-gallery]:not([data-t21-bound])').forEach(function (g) {
      g.setAttribute('data-t21-bound', '');
      var strip = g.querySelector('[data-t21-strip]');
      var prev = g.querySelector('[data-t21-gallery-prev]');
      var next = g.querySelector('[data-t21-gallery-next]');
      var dots = g.querySelectorAll('.t21-gallery__dots i');
      if (!strip || dots.length < 2) return;
      var count = dots.length, current = 0, target = -1, tick = false;
      function update() {
        tick = false;
        var w = strip.clientWidth || 1;
        current = Math.max(0, Math.min(count - 1, Math.round(strip.scrollLeft / w)));
        if (current === target) target = -1;
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === current); });
        if (prev) prev.hidden = current === 0;
        if (next) next.hidden = current === count - 1;
      }
      function go(dir) {
        /* quick double taps build on the slide we are already heading to */
        target = Math.max(0, Math.min(count - 1, (target >= 0 ? target : current) + dir));
        strip.scrollTo({ left: target * strip.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        track('t21_gallery', { product: strip.getAttribute('data-t21-product') });
      }
      strip.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      update();
    });
  }

  /* ---------- reveal on scroll ---------- */
  function bindReveal() {
    var els = document.querySelectorAll('[data-t21-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- sticky claim bar (phones) ---------- */
  function updateDock() {
    var dock = document.querySelector('[data-t21-dock]');
    var form = document.querySelector('.t21-offer');
    if (!dock || !form) return;
    var vh = window.innerHeight;
    var show = !document.documentElement.classList.contains('t21-is-claimed') && form.getBoundingClientRect().bottom < 0;
    document.querySelectorAll('[data-t21-hide-dock]').forEach(function (el) { if (el.getBoundingClientRect().top < vh) show = false; });
    dock.classList.toggle('is-visible', show);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
    dock.querySelectorAll('a, button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
  }
  var dockTick = false;
  window.addEventListener('scroll', function () {
    if (dockTick) return;
    dockTick = true;
    requestAnimationFrame(function () { dockTick = false; updateDock(); });
  }, { passive: true });
  window.addEventListener('resize', updateDock);

  function init() {
    try { cfg = JSON.parse((document.getElementById('T21Config') || {}).textContent || '{}'); } catch (e) {}
    bindForms(); bindReset(); bindCopy(); bindLinks(); bindCards(); bindPack(); bindGalleries(); bindReveal(); updateDock();
    /* Shopify customer-form fallback returns with ?customer_posted=true: the claim is saved but the
       code still has to be sent, so show the "on its way shortly" wording. A guest who already
       claimed through Klaviyo on this phone sees her gift again when she comes back. */
    var posted = /[?&]customer_posted=true/.test(location.search);
    var pending = store(PENDING);
    var sent = store(KEY);
    /* without Klaviyo the Shopify customer IS the claim (the Flow sends the gift card), so it is sent */
    if (posted) showClaimed(pending || '', { pending: !!cfg.listId, focus: true });
    else if (sent) showClaimed(sent, { instant: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
